import * as type from './types';

export function registerAdditional(data) {
    return {
      type: type.POST_REGISTER_ADDITIONAL_REQUESTED,
      data:data,
    }
  }